import {Dataset, DatasetDetail} from './dataset';
import {AccountDescriptor} from '../snapshots/account-descriptor';
import {SchoolFund} from '../funds/school-fund';
import {FinancialSummarySection} from '../snapshots/financial-summary-section';
import {ReportItem} from '../schools/report-item';
import {ReferenceLookup} from '../snapshots/reference-lookup';
import {BonanzaSchedule9Type} from '../snapshots/bonanza-schedule-9-type';
import {DebtCategoryItem} from '../snapshots/debt-category-item';

class Schools extends Dataset {
	override id!: never;
	constructor(data: Schools) {
		super(data);
	}
}

/**
 * todo type
 */
class SchoolsDetail extends DatasetDetail {
	includedYears!: Array<number>;
	indicatorNames!: Array<any>;
	reports!: Array<any>;
	funds!: Array<SchoolFund>;
	programs!: Array<any>;
	activities!: Array<any>;
	objects!: Array<any>;
	reportItems!: Array<ReportItem>;
	columns!: Array<any>;
	accountDescriptors!: Array<AccountDescriptor>;
	financialSummarySections!: Array<FinancialSummarySection>;
	bonanzaSchedule9Categories!: Array<ReferenceLookup<number>>;
	bonanzaSchedule9Types!: Array<BonanzaSchedule9Type>;
	debtCategoryItems!: Array<DebtCategoryItem>;

	constructor(data: Partial<SchoolsDetail>) {
		super(data);
	}
}

/**
 * Represents ~/api/Schools?$expand=detail
 */
export class SchoolsWithDetail extends Schools {
	detail: SchoolsDetail;

	constructor(data: SchoolsWithDetail) {
		super(data);
		this.detail = new SchoolsDetail(data.detail);
	}
}
